/**
 * Shared text utility functions
 */

/**
 * Truncate text to a specified number of words
 * @param text - The text to truncate
 * @param wordLimit - Maximum number of words (default: 5)
 * @returns Object containing truncated text and whether it was truncated
 */
export const truncateToWords = (
  text: string,
  wordLimit: number = 5
): { text: string; isTruncated: boolean } => {
  const words = text.trim().split(/\s+/);
  if (words.length <= wordLimit) {
    return { text, isTruncated: false };
  }
  return { text: words.slice(0, wordLimit).join(' ') + '...', isTruncated: true };
};

/**
 * Copy text to clipboard
 * @param text - The text to copy
 * @returns Promise that resolves when copy is complete
 */
export const copyToClipboard = async (text: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error('Failed to copy text:', err);
  }
};
